<template>
    <div id="region">
        <el-scrollbar :class="isCollapse ? 'menu_hide rightSide' : 'rightSide'">
            <el-main>
                <!--                <el-breadcrumb separator-class="el-icon-arrow-right" class="mainBread">-->
                <!--                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>-->
                <!--                    <el-breadcrumb-item :to="{ path: '/' }">系统配置</el-breadcrumb-item>-->
                <!--                    <el-breadcrumb-item>地域设置</el-breadcrumb-item>-->
                <!--                </el-breadcrumb>-->
                <nav-bar></nav-bar>
                <template>
                    <el-tabs v-model="activeTab" @tab-click="handleClick">
                        <el-tab-pane v-if="judge('Region_ViewCityTab')" name="first">
                            <span slot="label"><i class="el-icon-location-information"></i> {{$t('City')}}</span>
                            <template>
                                <el-form ref="citySelect" :model="citySelect" label-width="80px" class="queryform_div">
                                    <el-form-item :label="$t('City')">
                                        <el-input class="queryform" @keyup.enter.native="getDataList"
                                            v-model="citySelect.queryString">
                                        </el-input>
                                    </el-form-item>

                                    <el-form-item>
                                        <el-button type="primary" @click="getDataList">{{ $t('Query') }}</el-button>
                                        <el-button @click="reset">{{ $t('Reset') }}</el-button>
                                    </el-form-item>
                                </el-form>

                                <el-button type="primary" v-if="judge('Region_CreateCity')"
                                    icon="el-icon-circle-plus-outline" @click="openAdd" style="margin-bottom:10px;">{{ $t('AddCity') }}
                                </el-button>
                                <el-table :data="tableDataCity" border style="width:100%; ">
                                    <el-table-column type="index" min-width="5%">
                                    </el-table-column>
                                    <el-table-column prop="cityName" :label="$t('CityName')" min-width="30%">
                                    </el-table-column>
                                    <el-table-column prop="" :label="$t('Citylnglat')" min-width="35%" :formatter="fileData">
                                    </el-table-column>
                                    <el-table-column :label="$t('Action')" min-width="30%">
                                        <template slot-scope="scope">
                                            <el-button size="mini" type="primary" v-if="judge('Region_UpdateCity')"
                                                @click="openEdit(scope.row)">{{ $t('Edit') }}
                                            </el-button>
                                            <template v-if="judge('Region_DeleteCity')">
                                                <el-popconfirm placement="top"
                                                :confirmButtonText="$t('Delete')"
                                                :cancelButtonText="$t('Cancel')"
                                                    icon="el-icon-info" iconColor="red"  :title="$t('DeleteConfirm')"
                                                    @onConfirm="deleteInfo(scope.row)">
                                                    <el-button size="mini" type="danger" slot="reference"
                                                        style=" margin-left: 10px;">{{ $t('Delete') }}
                                                    </el-button>
                                                </el-popconfirm>
                                            </template>
                                        </template>
                                    </el-table-column>
                                </el-table>
                                <el-pagination background layout="prev, pager, next" :total="pagination.totalPage"
                                    :current-page.sync="pagination.current" :page-size="pagination.pageSize"
                                    @current-change="pageChange()"></el-pagination>
                            </template>

                        </el-tab-pane>
                        <el-tab-pane v-if="judge('Region_ViewFactoryBuildTab')" name="second">
                            <span slot="label"><i class="el-icon-office-building"></i>{{ $t('CampusBuilding') }}</span>
                            <template>

                                <el-form ref="factorySelect" :model="factorySelect" label-width="80px"
                                    class="queryform_div">
                                    <!-- <el-form-item label="城市名">
                                        <el-input @keyup.enter.native="getDataList" class="queryform" v-model="factorySelect.cityName">
                                        </el-input>
                                    </el-form-item>

                                    <el-form-item label="园区名">
                                        <el-input @keyup.enter.native="getDataList" class="queryform" v-model="factorySelect.factoryName">
                                        </el-input>
                                    </el-form-item> -->
                                    <areaSelect :hasDeviceName="false" :level="2" :deviceType="deviceType"
                                        :formArea="formArea" :enablesys="'1'" @areaList="getAreaList"></areaSelect>

                                    <el-form-item :label="$t('BuildingName')">
                                        <el-input @keyup.enter.native="getDataList" class="queryform"
                                            v-model="factorySelect.buildingName">
                                        </el-input>
                                    </el-form-item>

                                    <el-form-item>
                                        <el-button type="primary" @click="getDataList">{{ $t('Query') }}</el-button>
                                        <el-button @click="reset">{{ $t('Reset') }}</el-button>
                                    </el-form-item>
                                </el-form>

                                <el-button type="primary" v-if="judge('Region_CreateFactory')"
                                    icon="el-icon-circle-plus-outline" @click="openAdd" style="margin-bottom:10px;">
                                  {{ $t('AddCampus') }}
                                </el-button>
                                <el-button type="primary" v-if="judge('Region_CreateBuilding')"
                                    icon="el-icon-circle-plus-outline" @click="openAddBuilding"
                                    style="margin-bottom:10px;">{{ $t('AddBuilding') }}
                                </el-button>
                                <!--              <el-button type="primary" icon="el-icon-circle-plus-outline" @click="openDelete" style="margin-bottom:10px;">删除园区</el-button>-->

                                <el-table :data="tableDataFactory" border style="width:100%; ">
                                    <el-table-column type="index" min-width="5%">
                                    </el-table-column>
                                    <el-table-column prop="cityName" :label="$t('City')" min-width="8%">
                                    </el-table-column>
                                    <el-table-column prop="factoryName" :label="$t('CampusName')" min-width="15%">
                                    </el-table-column>
                                    <el-table-column prop="buildingName" :label="$t('BuildingName')" min-width="15%">
                                    </el-table-column>
                                    <el-table-column prop="" :label="$t('Floor')" min-width="25%" :formatter="mergeFloor">
                                    </el-table-column>
                                    <el-table-column :label="$t('Action')" min-width="40%">
                                        <template slot-scope="scope">
                                            <el-button size="mini" type="primary" v-if="judge('Region_UpdateFactory')"
                                                @click="openEdit(scope.row)">{{ $t('EditCampus') }}
                                            </el-button>
                                            <template v-if="!scope.row.buildingName">
                                                <el-popconfirm placement="top"   :confirmButtonText="$t('Delete')"
                                                :cancelButtonText="$t('Cancel')"
                                                    icon="el-icon-info" iconColor="red"  :title="$t('DeleteConfirm')"
                                                    @onConfirm="deleteFactoryInfo(scope.row)" style="margin-right: 5px;">
                                                    <el-button size="mini" type="danger" slot="reference"
                                                        v-if="judge('Region_DeleteFactory')"
                                                        style=" margin-left: 10px;">{{ $t('DeletePark') }}
                                                    </el-button>
                                                </el-popconfirm>
                                            </template>

                                            <el-button size="mini" type="primary" v-if="judge('Region_UpdateBuilding')"
                                                @click="openBuildingConfig(scope.row)">{{ $t('EditBuilding') }}
                                            </el-button>

                                            <template v-if="scope.row.buildingName">
                                                <el-popconfirm placement="top"   :confirmButtonText="$t('Delete')" :cancelButtonText="$t('Cancel')"
                                                    icon="el-icon-info" iconColor="red"  :title="$t('DeleteConfirm')"
                                                    @onConfirm="deleteInfo(scope.row)">
                                                    <el-button size="mini" type="danger" slot="reference"
                                                        v-if="judge('Region_DeleteBuilding')"
                                                        style=" margin-left: 10px;">{{ $t('DeleteBuilding') }}
                                                    </el-button>
                                                </el-popconfirm>
                                            </template>

                                        </template>
                                    </el-table-column>
                                </el-table>

                                <el-pagination background layout="prev, pager, next" :total="pagination.totalPage"
                                    :current-page.sync="pagination.current" :page-size="pagination.pageSize"
                                    @current-change="pageChange()"></el-pagination>
                            </template>
                        </el-tab-pane>
                        <el-tab-pane v-if="judge('Region_ViewLabTab')" name="third">
                            <span slot="label"><i class="el-icon-odometer"></i> {{ $t('Lab') }}</span>
                            <template>

                                <el-form ref="labSelect" :model="labSelect" label-width="80px" class="queryform_div">

                                    <!-- <el-form-item label="城市名">
                                        <el-input @keyup.enter.native="getDataList" class="queryform" v-model="labSelect.cityName">
                                        </el-input>
                                    </el-form-item>

                                    <el-form-item label="园区名">
                                        <el-input @keyup.enter.native="getDataList" class="queryform" v-model="labSelect.factoryName">
                                        </el-input>
                                    </el-form-item>

                                    <el-form-item label="楼宇名">
                                        <el-input @keyup.enter.native="getDataList" class="queryform" v-model="labSelect.buildingName">
                                        </el-input>
                                    </el-form-item> -->
                                    <areaSelect :hasDeviceName="false" :level="3" :deviceType="deviceType"
                                        :formArea="formArea" :enablesys="'1'" @areaList="getAreaList"></areaSelect>
                                    <el-form-item :label="$t('LabName')" style="    width: auto;">
                                        <el-input @keyup.enter.native="getDataList" class="queryform"
                                            v-model="labSelect.labName">
                                        </el-input>
                                    </el-form-item>
                                    <el-form-item label="Space ID" style="width: auto;margin-left: 20px;">
                                        <el-input @keyup.enter.native="getDataList" class="queryform"
                                            v-model="labSelect.SpaceID">
                                        </el-input>
                                    </el-form-item>
                                    <el-form-item>
                                        <el-button type="primary" @click="getDataList">{{ $t('Query') }}</el-button>
                                        <el-button @click="reset">{{ $t('Reset') }}</el-button>
                                    </el-form-item>
                                </el-form>

                                <el-button type="primary" icon="el-icon-circle-plus-outline"
                                    v-if="judge('Region_CreateLaboratory')" @click="openAdd"
                                    style="margin-bottom:10px;">{{ $t('AddLab') }}
                                </el-button>
                                <el-table :data="tableDataLab" border style="width:100%; ">
                                    <el-table-column type="index" min-width="5%">
                                    </el-table-column>
                                    <el-table-column prop="labName" :label="$t('LabName')" min-width="20%">
                                    </el-table-column>
                                    <el-table-column prop="" :label="$t('LabAddress')" min-width="30%" :formatter="mergeLabAddress">
                                    </el-table-column>
                                    <el-table-column prop="SpaceID" label="Space ID" min-width="20%">
                                    </el-table-column>
                                    <el-table-column :label="$t('Action')" min-width="15%">
                                        <template slot-scope="scope">
                                            <el-button size="mini" type="primary" v-if="judge('Region_UpdateLaboratory')"
                                                @click="openEdit(scope.row)">{{ $t('Edit') }}
                                            </el-button>
                                            <template v-if="judge('Region_DeleteLaboratory')">
                                                <el-popconfirm placement="top"   :confirmButtonText="$t('Delete')" :cancelButtonText="$t('Cancel')"
                                                    icon="el-icon-info" iconColor="red"  :title="$t('DeleteConfirm')"
                                                    @onConfirm="deleteInfo(scope.row)">
                                                    <el-button size="mini" type="danger" slot="reference"
                                                        style=" margin-left: 10px;">{{ $t('Delete') }}
                                                    </el-button>
                                                </el-popconfirm>
                                            </template>
                                        </template>
                                    </el-table-column>
                                </el-table>

                                <el-pagination background layout="prev, pager, next" :total="pagination.totalPage"
                                    :current-page.sync="pagination.current" :page-size="pagination.pageSize"
                                    @current-change="pageChange()"></el-pagination>
                            </template>
                        </el-tab-pane>
                    </el-tabs>
                </template>
            </el-main>
        </el-scrollbar>

        <el-dialog :title="$t('AddCity')" v-if="dialogAddCity" :visible.sync="dialogAddCity" width="60%" top="10vh"
            @close="closeAddDialog">
            <el-form ref="cityAddForm" :model="cityAddForm" label-width="150px">
                <el-form-item  :label="$t('CityCode')" prop="cityCode" :rules="[{ required: true, message: $t('NameNotEmpty') }]">
                    <el-input v-model="cityAddForm.cityCode" style="width: 300px;" :placeholder="$t('Enter')"></el-input>
                </el-form-item>

                <el-form-item :label="$t('CityName')" prop="cityName" :rules="[{ required: true, message: $t('NameNotEmpty') }]">
                    <el-input v-model="cityAddForm.cityName" style="width: 300px;" :placeholder="$t('Enter')"></el-input>
                </el-form-item>
                <!--        <el-form-item label="城市编码"-->
                <!--          prop="cityCode"-->
                <!--          :rules="[{required: true, message: '编码不能为空'}]"-->
                <!--        >-->
                <!--          <el-input v-model="cityEditForm.cityCode" style="width: 300px;" :placeholder="$t('Enter')"></el-input>-->
                <!--        </el-form-item>-->

                <el-form-item :label="$t('X')" prop="longitude" :rules="[{ required: true, message: $t('TheX-axisCoordinate') }]">
                    <el-input v-model="cityAddForm.longitude" style="width: 300px;" :placeholder="$t('PleaseEnterX-axis')"></el-input>
                </el-form-item>
                <el-form-item :label="$t('Y')" prop="latitude" :rules="[{ required: true, message: $t('Y-axisCoordinates') }]">
                    <el-input v-model="cityAddForm.latitude" style="width: 300px;" :placeholder="$t('PleaseEnterY-axisCoordinates')"></el-input>
                </el-form-item>
                <el-form-item :label="$t('Remarks')">
                    <el-input v-model="cityAddForm.remark" type="textarea" :rows="2" :placeholder="$t('Enter')"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="success" @click="addInfo('cityAddForm')">{{ $t('Confirm') }}</el-button>
                    <el-button @click="cancelAdd">{{ $t('Cancel') }}</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <el-dialog :title="$t('EditCityInformation')" v-if="dialogEditCity" :visible.sync="dialogEditCity" width="60%" top="10vh">
            <el-form ref="cityEditForm" :model="cityEditForm" label-width="150px">
                <el-form-item :label="$t('CityCode')" prop="cityCode" :rules="[{ required: true, message: $t('NameNotEmpty') }]">
                    <el-input style="width: 300px;" v-model="cityEditForm.cityCode"></el-input>
                </el-form-item>

                <el-form-item :label="$t('CityName')" prop="cityName" :rules="[{ required: true, message: $t('NameNotEmpty') }]">
                    <el-input style="width: 300px;" v-model="cityEditForm.cityName"></el-input>
                </el-form-item>

                <el-form-item :label="$t('X')">
                    <el-input style="width: 300px;" v-model="cityEditForm.longitude" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item :label="$t('Y')">
                    <el-input style="width: 300px;" v-model="cityEditForm.latitude" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item :label="$t('Remarks')">
                    <el-input type="textarea" :rows="2" v-model="cityEditForm.remark"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="success" @click="editInfo('cityEditForm')">{{ $t('Confirm') }}</el-button>
                    <el-button @click="dialogEditCity = false">{{ $t('Cancel') }}</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

        <el-dialog :title="$t('AddCampus')" :visible.sync="dialogAddFactory" width="60%" top="10vh" @close="closeAddDialog">
            <el-form ref="factoryAddForm" :model="factoryAddForm" label-width="150px">
                <el-form-item :label="$t('City')" prop="cityId" :rules="[{ required: true, message: $t('NameNotEmpty') }]">
                    <el-select v-model="factoryAddForm.cityId" :placeholder="$t('el.select.placeholder')" style="width: 300px;">
                        <el-option v-for="item in cityList" :key="item.id" :label="item.cityName" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item :label="$t('CampusCode')" prop="factoryCode" :rules="[{ required: true, message: $t('NameNotEmpty') }]">
                    <el-input style="width: 300px;" v-model="factoryAddForm.factoryCode"></el-input>
                </el-form-item>

                <el-form-item :label="$t('CampusName')" prop="factoryName" :rules="[{ required: true, message: $t('NameNotEmpty') }]">
                    <el-input style="width: 300px;" v-model="factoryAddForm.factoryName"></el-input>
                </el-form-item>
                <!--                <el-form-item :label="$t('Building')" prop="buildings" :rules="[{required: true, message: '楼宇不能为空'}]">-->
                <el-form-item :label="$t('Building')">
                    <template>
                        <el-table :data="factoryAddForm.buildings" ref="buildings" border class="formSTable">
                            <el-table-column :label="$t('Action')" width="52px">
                                <template slot-scope="scope">
                                    <el-button icon="el-icon-delete" circle size="mini" type="danger"
                                        @click="delBuildRow(scope.$index, scope.row)"></el-button>
                                </template>
                            </el-table-column>

                            <el-table-column :label="$t('BuildingCode')" min-width="35%">
                                <template slot-scope="scope">
                                    <el-input v-model="scope.row.buildingCode"></el-input>
                                </template>
                            </el-table-column>

                            <el-table-column :label="$t('BuildingName')" min-width="35%">
                                <template slot-scope="scope">
                                    <el-input v-model="scope.row.buildingName"></el-input>
                                </template>
                            </el-table-column>


                            <el-table-column :label="$t('BuildingRemark')">
                                <template slot-scope="scope">
                                    <el-input type="textarea" :rows="1" v-model="scope.row.buildingRemark"></el-input>
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-button class="el-icon-plus" @click.prevent="addBuildRow()"></el-button>
                    </template>
                </el-form-item>
                <el-form-item :label="$t('CampusRemark')">
                    <el-input type="textarea" :rows="2" v-model="factoryAddForm.factoryRemark"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="success" @click="addInfo('factoryAddForm')">{{ $t('Confirm') }}</el-button>
                    <el-button @click="cancelAdd">{{ $t('Cancel') }}</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

        <el-dialog :title="$t('AddBuilding')" :visible.sync="dialogAddBuilding" width="60%" top="10vh" @close="closeAddBuildingDialog">
            <el-form ref="buildingAddForm" :model="buildingAddForm" label-width="150px">
                <el-form-item :label="$t('City')" prop="cityId" :rules="[{ required: true, message: $t('NameNotEmpty') }]">
                    <el-select v-model="buildingAddForm.cityId" :placeholder="$t('el.select.placeholder')" style="width: 300px;"
                        @change="getFactoryByCityId">
                        <el-option v-for="item in cityList" :key="item.id" :label="item.cityName" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('Campus')" prop="factoryId" :rules="[{ required: true, message: $t('NameNotEmpty') }]">
                    <el-select v-model="buildingAddForm.factoryId" :placeholder="$t('el.select.placeholder')" style="width: 300px;">
                        <el-option v-for="item in factoryList" :key="item.id" :label="item.factoryName" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item :label="$t('BuildingCode')" prop="buildingCode" :rules="[{ required: true, message: $t('NameNotEmpty') }]">
                    <el-input style="width: 300px;" v-model="buildingAddForm.buildingCode" :placeholder="$t('Enter')"></el-input>
                </el-form-item>

                <el-form-item :label="$t('BuildingName')" prop="buildingName" :rules="[{ required: true, message: $t('NameNotEmpty') }]">
                    <el-input style="width: 300px;" v-model="buildingAddForm.buildingName" :placeholder="$t('Enter')"></el-input>
                </el-form-item>
                <el-form-item :label="$t('Remarks')">
                    <el-input style="width: 300px;" type="textarea" v-model="buildingAddForm.remark" :rows="3"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="success" @click="addBuildingInfo('buildingAddForm')">{{ $t('Confirm') }}</el-button>
                    <el-button @click="cancelAddBuilding">{{ $t('Cancel') }}</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>


        <el-dialog :title="$t('EditCampus')" :visible.sync="dialogEditFactory" width="60%" top="10vh">
            <el-form ref="factoryEditForm" :model="factoryEditForm" label-width="150px">
                <el-form-item :label="$t('City')">
                    <el-select v-model="factoryEditForm.cityId" :placeholder="$t('el.select.placeholder')" style="width: 300px;">
                        <el-option v-for="item in cityList" :key="item.id" :label="item.cityName" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item :label="$t('CampusCode')">
                    <el-input style="width: 300px;" v-model="factoryEditForm.factoryCode" :disabled="true"></el-input>
                </el-form-item>

                <el-form-item :label="$t('CampusName')" prop="factoryName" :rules="[{ required: true, message: $t('NameNotEmpty') }]">
                    <el-input style="width: 300px;" v-model="factoryEditForm.factoryName"></el-input>
                </el-form-item>
                <el-form-item :label="$t('Building')" prop="buildingName" :rules="[{ required: true, message: $t('NameNotEmpty') }]">
                    <el-input style="width: 300px;" v-model="factoryEditForm.buildingName"></el-input>
                </el-form-item>
                <el-form-item :label="$t('CampusRemark')">
                    <el-input type="textarea" :rows="2" v-model="factoryEditForm.factoryRemark"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="success" @click="editInfo('factoryEditForm')">{{ $t('Confirm') }}</el-button>
                    <el-button @click="dialogEditFactory = false">{{ $t('Cancel') }}</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

        <el-dialog :title="$t('EditBuilding')" :visible.sync="dialogBuilding" width="60%" top="10vh">
            <el-form ref="buildingEditForm" :model="buildingEditForm" label-width="150px">
                <el-form-item :label="$t('City')">
                    <el-input style="width: 300px;" :value="buildingEditForm.cityName" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item :label="$t('CampusName')">
                    <el-input style="width: 300px;" :value="buildingEditForm.factoryName" :disabled="true"></el-input>
                </el-form-item>

                <el-form-item :label="$t('BuildingCode')">
                    <el-input style="width: 300px;" :value="buildingEditForm.buildingCode" :disabled="true"></el-input>
                </el-form-item>

                <el-form-item :label="$t('Building')">
                    <el-input style="width: 300px;" :value="buildingEditForm.buildingName" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item :label="$t('Floor')">
                    <template>
                        <el-table :data="buildingEditForm.floor" ref="floor" border class="formSTable">
                            <el-table-column :label="$t('Action')" width="52px">
                                <template slot-scope="scope">
                                    <el-button icon="el-icon-delete" circle size="mini" type="danger"
                                        @click="delFloorRow(scope.$index)"></el-button>
                                </template>
                            </el-table-column>
                            <el-table-column :label="$t('Floor')">
                                <template slot-scope="scope">
                                    <el-input v-model="scope.row.floorName"></el-input>
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-button class="el-icon-plus" @click.prevent="addFloorRow()"></el-button>
                    </template>
                </el-form-item>
                <el-form-item :label="$t('BuildingRemark')">
                    <el-input type="textarea" :rows="2" v-model="buildingEditForm.buildingRemark"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="success" @click="editFloorInfo">{{ $t('Confirm') }}</el-button>
                    <el-button @click="dialogBuilding = false">{{ $t('Cancel') }}</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

        <el-dialog :title="$t('AddLab')" :visible.sync="dialogAddLab" width="60%" top="10vh" @close="closeAddDialog">
            <el-form ref="labAddForm" :model="labAddForm" label-width="150px">
                <el-form-item :label="$t('City')" prop="cityId" :rules="[{ required: true, message: $t('NameNotEmpty') }]">
                    <el-select v-model="labAddForm.cityId" :placeholder="$t('el.select.placeholder')" style="width: 300px;"
                        @change="getFactoryByCityId">
                        <el-option v-for="item in cityListNew" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('Campus')" prop="factoryId" :rules="[{ required: true, message: $t('NameNotEmpty') }]">
                    <el-select v-model="labAddForm.factoryId" :placeholder="$t('el.select.placeholder')" style="width: 300px;"
                        @change="getBuildingByFactoryId">
                        <el-option v-for="item in factoryList" :key="item.id" :label="item.factoryName" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('Building')" prop="buildingId" :rules="[{ required: true, message: $t('NameNotEmpty') }]">
                    <el-select v-model="labAddForm.buildingId" :placeholder="$t('el.select.placeholder')" style="width: 300px;"
                        @change="getFloorByBuildingId">
                        <el-option v-for="item in buildingList" :key="item.id" :label="item.buildingName" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('Floor')">
                    <el-select v-model="labAddForm.floorId" prop="floorId" :placeholder="$t('el.select.placeholder')" style="width: 300px;">
                        <el-option v-for="item in floorList" :key="item.id" :label="item.floorName" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item :label="$t('LabCode')" prop="labCode" :rules="[{ required: true, message: $t('NameNotEmpty') }]">
                    <el-input style="width: 300px;" v-model="labAddForm.labCode" :placeholder="$t('Enter')"></el-input>
                </el-form-item>

                <el-form-item :label="$t('LabName')" prop="labName" :rules="[{ required: true, message: $t('NameNotEmpty') }]">
                    <el-input style="width: 300px;" v-model="labAddForm.labName" :placeholder="$t('Enter')"></el-input>
                </el-form-item>
                <el-form-item label="IP" prop="ip" :rules="[{ required: true, message: 'IP不能为空' }]">
                    <el-input style="width: 300px;" v-model="labAddForm.ip" :placeholder="$t('Enter')"></el-input>
                </el-form-item>
                <el-form-item label="Space ID" prop="SpaceIDList" >
                    <template>
                        <el-table :data="labform.SpaceIDList" ref="SpaceIDList"
                            style="width: 100%;border:1px solid rgba(137,137,137,0.2)">
                            <el-table-column label="" width="50">
                                <template slot-scope="scope">
                                    <el-button type="danger" icon="el-icon-delete" circle size="mini" style="display: block"
                                        @click="DelRow(scope.$index, scope.row)"></el-button>
                                </template>
                            </el-table-column>
                            <el-table-column type="index" :label="$t('SN')" width="80">
                            </el-table-column>
                            <el-table-column label="Space ID" max-width="200">
                                <template slot-scope="scope">
                                    <el-input v-model="scope.row.SpaceID" @input="handleInputNoComma(scope.row)"></el-input>
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-button icon="el-icon-circle-plus-outline" size="mini" style="display: block;margin-top: -1px;"
                            @click="createRow"></el-button>
                    </template>
                </el-form-item>
                <el-form-item :label="$t('Contacts')" prop="contactName" :rules="[{ required: true, message: $t('ContactPersonEmpty') }]">
                    <el-input style="width: 300px;" v-model="labAddForm.contactName" :placeholder="$t('Enter')"></el-input>
                </el-form-item>
                <el-form-item :label="$t('Contact Phone')" maxLength="11" prop="contactMobile"
                    :rules="[{ required: true, message: $t('ContactNumberEmpty') }]">
                    <el-input style="width: 300px;" v-model="labAddForm.contactMobile" :placeholder="$t('Enter')"></el-input>
                </el-form-item>
                <el-form-item :label="$t('Remarks')">
                    <el-input style="width: 300px;" type="textarea" v-model="labAddForm.remark" :rows="3"></el-input>
                </el-form-item>
                <el-form-item :label="$t('ImageUpload')">
                    <el-upload class="avatar-uploader" accept="picture" list-type="picture" :action="getUrl()"
                        :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload"
                        :on-error="handleUploadError">
                        <img v-if="labAddForm.labPicUrl" :src="labAddForm.labPicUrl" class="avatar"
                            alt="Failed to load image">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
                <el-form-item>
                    <el-button type="success" @click="addInfo('labAddForm')">{{ $t('Confirm') }}</el-button>
                    <el-button @click="cancelAdd">{{ $t('Cancel') }}</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

        <el-dialog :title="$t('EditLaboratoryInformation')" :visible.sync="dialogEditLab" width="60%" top="10vh">
            <el-form ref="labform" :model="labform" label-width="150px">
                <!-- <el-form-item label="城市">
                    <el-input style="width: 300px;" :value="labform.cityName" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="园区">
                    <el-input style="width: 300px;" :value="labform.factoryName" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="楼宇">
                    <el-input style="width: 300px;" :value="labform.buildingName" :disabled="true"></el-input>
                </el-form-item> -->
                <el-form-item :label="$t('City')">
                    <el-select :placeholder="$t('el.select.placeholder')" @change="getFac()" v-model="labform.cityId" style="width: 300px;">
                        <el-option v-for="(item, index) in area" :key="'inx1' + index" :value="item.value"
                            :label="item.label"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('Campus')">
                    <el-select :placeholder="$t('el.select.placeholder')" @change="getBuild()" v-model="labform.factoryId" style="width: 300px;">
                        <el-option v-for="(item, index) in facList" :key="'inx2' + index" :value="item.value"
                            :label="item.label"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('Building')" prop="buildingId">
                    <el-select :placeholder="$t('el.select.placeholder')" @change="getLab()" v-model="labform.buildingId" style="width: 300px;">
                        <el-option v-for="(item, index) in building" :key="'inx3' + index" :value="item.value"
                            :label="item.label"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('Floor')">
                    <!-- <el-input style="width: 300px;" :value="labform.floorName" :disabled="true"></el-input> -->
                    <el-select v-model="labform.floorId" prop="floorId" :placeholder="$t('el.select.placeholder')" style="width: 300px;">
                        <el-option value="00000000-0000-0000-0000-000000000000" label="无"></el-option>
                        <el-option v-for="(item, index) in floorList" :key="'inx4' + index" :label="item.floorName"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('LabName')" prop="labName" :rules="[{ required: true, message: $t('NameNotEmpty') }]">
                    <el-input style="width: 300px;" v-model="labform.labName"></el-input>
                </el-form-item>
                <el-form-item label="IP" prop="ip" :rules="[{ required: true, message: 'IP不能为空' }]">
                    <el-input style="width: 300px;" v-model="labform.ip" :placeholder="$t('Enter')"></el-input>
                </el-form-item>

                <el-form-item label="Space ID" prop="SpaceIDList">
                    <template>
                        <el-table :data="labform.SpaceIDList" ref="SpaceIDList"
                            style="width: 100%;border:1px solid rgba(137,137,137,0.2)">
                            <el-table-column label="" width="50">
                                <template slot-scope="scope">
                                    <el-button type="danger" icon="el-icon-delete" circle size="mini" style="display: block"
                                        @click="DelRow(scope.$index, scope.row)"></el-button>
                                </template>
                            </el-table-column>
                            <el-table-column type="index" :label="$t('SN')" width="80">
                            </el-table-column>
                            <el-table-column label="Space ID" max-width="200">
                                <template slot-scope="scope">
                                    <el-input v-model="scope.row.SpaceID" @input="handleInputNoComma(scope.row)"></el-input>
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-button icon="el-icon-circle-plus-outline" size="mini" style="display: block;margin-top: -1px;"
                            @click="createRow"></el-button>
                    </template>
                </el-form-item>
                <el-form-item :label="$t('Contacts')" prop="contactName" :rules="[{ required: true, message: $t('ContactPersonEmpty') }]">
                    <el-input style="width: 300px;" v-model="labform.contactName" :placeholder="$t('Enter')"></el-input>
                </el-form-item>
                <el-form-item :label="$t('Contact Phone')" maxLength="11" prop="contactMobile"
                    :rules="[{ required: true, message: $t('ContactNumberEmpty') }]">
                    <el-input style="width: 300px;" v-model="labform.contactMobile" :placeholder="$t('Enter')"></el-input>
                </el-form-item>
                <el-form-item :label="$t('ImageUpload')">
                    <el-upload class="avatar-uploader" accept="picture" list-type="picture" :action="getUrl()"
                        :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload"
                        :on-error="handleUploadError">
                        <img v-if="labform.labPicUrl" :src="labform.labPicUrl" class="avatar" alt="Failed to load image">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
                <el-form-item :label="$t('Remarks')">
                    <el-input type="textarea" v-model="labform.remark" :rows="3"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="success" @click="editInfo('labform')">{{ $t('Confirm') }}</el-button>
                    <el-button @click="dialogEditLab = false">{{ $t('Cancel') }}</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

    </div>
</template>

<script>
import {
    getCityAll,
    addCity,
    editCity,
    deleteCity,
    getFactoryAll,
    getLabAll,
    editLab,
    deleteLab,
    addLab,
    GetCityList,
    GetByCityId,
    GetByFactoryId,
    GetByBuildingId,
    addFactory,
    editFactory,
    editFloor,
    deleteBuilding,
    GetCreateLabInital,
    getFactoryAlls,
    deleteFactory,
    addBuilding

} from "../../api/api";
import { mapState } from 'vuex';
import { imgActionUrl } from '../../../utils/http';

import { judgePermission, fancha } from '../../utils/util'
import areaSelect from '../../components/content/maintabber/areaSelect'
export default {
    name: "Region",
    components: {
        areaSelect,
    },
    async mounted() {
        this.activeTab = this.judge('Region_ViewCityTab') ? 'first' : (this.judge('Region_ViewFactoryBuildTab') ? 'second' : 'third')
        if (this.judge('Region_ViewCityTab') || this.judge('Region_ViewFactoryBuildTab') || this.judge('Region_ViewLabTab')) {
            this.getDataList();
        }
        this.cityListNew = JSON.parse(sessionStorage.getItem("deviceList"))[0].children
        // console.log(sessionStorage.getItem("userName"))
        // this.labform.contactName = sessionStorage.getItem("userName")
        // this.labAddForm.contactName = sessionStorage.getItem("userName")
    },

    data() {
        return {
            area: JSON.parse(sessionStorage.getItem("area")),
            formArea: { cityId: "", factoryId: "", buildingId: "", LabId: "", deviceId: "" },
            deviceType: "",
            cityListNew: [],
            facList: [],
            building: [],
            labList: [],
            imageUrl: '',
            dialogEditLab: false,
            activeTab: 'first',
            dialogAddCity: false,
            dialogEditCity: false,
            dialogAddPark: false,
            dialogEditFactory: false,
            dialogDeleteFactory: false,
            dialogBuilding: false,
            dialogAddFactory: false,
            dialogAddLab: false,
            dialogAddBuilding: false,
            citySelect: {
                queryString: ''
            },
            factorySelect: {
                cityName: '',
                factoryName: '',
                buildingName: ''
            },
            labSelect: {
                labName: '',
                cityName: '',
                factoryName: '',
                buildingName: '',
                SpaceID: "",
            },


            cityEditForm: {
                cityName: '',
                cityCode: '',
                latitude: '',
                longitude: '',
                remark: ''
            },
            cityAddForm: {
                cityName: '',
                cityCode: '',
                longitude: '',
                latitude: '',
                remark: ''
            },
            factoryEditForm: {
                cityId: '',
                factoryName: '',
                buildingId: '',
                buildingName: '',
                factoryCode: '',
                factoryRemark: '',
                id: ''
            },

            buildingAddForm: {
                cityId: '',
                factoryId: '',
                buildingCode: '',
                buildingName: '',
                remark: ''
            },

            buildingEditForm: {
                cityId: '',
                factoryName: '',
                buildingId: '',
                buildingName: '',
                floor: [],
                buildingRemark: '',
                id: ''
            },

            factoryAddForm: {
                cityId: '',
                factoryCode: '',
                factoryName: '',
                buildings: [],
                factoryRemark: ''
            },
            factoryDeleteForm: {
                factoryId: ''
            },

            labform: {
                cityId: '',
                factoryId: '',
                buildingId: '',
                floorId: '',
                labName: '',
                remark: '',
                ip: '',
                contactName: '',
                contactMobile: '',
                labPicUrl: '',
                SpaceIDList:[
                ]
            },
            labAddForm: {
                cityId: '',
                factoryId: '',
                buildingId: '',
                floorId: '',
                labCode: '',
                labName: '',
                remark: '',
                ip: '',
                contactName: '',
                contactMobile: '',
                labPicUrl: '',
                SpaceIDList: [],
            },

            cityList: [],
            factoryList: [],
            labList: [],
            buildingList: [],
            floorList: [],
            tableDataCity: [],
            tableDataFactory: [],
            tableDataLab: [],
            BuildingTable: [],
            floorTable: [],
            BuildingrowNum: 1,
            FloorrowNum: 1,

            pagination: {
                current: 1,
                pageSize: 6,
                totalPage: 0
            },
            sorter: { field: 'Id', order: 'asc' },

            formselect: {
                cityId: "",
                factoryId: "",
                buildingId: "",
                LabId: "",
            },
        }
    },
    computed: mapState({
        isCollapse: state => state.isCollapse
    }),
    methods: {
        // SpaceID 表格 新建删除事件 Start
        createRow() { //添加新的行数
            var newValue = {
                IDIndex: this.IDIndex++,
                SpaceID: "",
            };
            //添加新的行数
            if(!this.labform.SpaceIDList)
            {
                this.labform.SpaceIDList = [];
            }
            this.labform.SpaceIDList.push(newValue);
        },

        DelRow(index) {//删除行
            this.labform.SpaceIDList.splice(index, 1);
        },

        handleInputNoComma(Row) {
            // 阻止逗号的输入
            const value = Row.SpaceID;
            if (value.includes(",")||value.includes("，")) {
                Row.SpaceID = value.replace(/[,，]/g, ''); // 替换逗号为空字符串
            }
        },

        // SpaceID 表格 新建删除事件 End


        judge(e) {
            return judgePermission(e)
        },
        getAreaList(e) {
            this.formselect = { ...this.formselect, ...e.Valueform }
            // if(this.formselect.DeviceName){
            //     this.selectByKeyword()
            // }
        },
        getUrl() {
            let imgactionurl = '';
            if (process.env.NODE_ENV === 'development') {
                imgactionurl = process.env.VUE_APP_LocalRootUrl + 'api/services/app/CommonService/TestFileUpload'; //这是调用测试数据接口
            } else {
                imgactionurl = process.env.VUE_APP_PublishRootUrl + 'api/services/app/CommonService/TestFileUpload'; //线上
            }
            return imgactionurl;
        },
        handleAvatarSuccess(res, file) {
            // this.imageUrl = res.result
            this.labform.labPicUrl = res.result + "?sv=2020-02-10&ss=bfqt&srt=co&sp=rwdlacupx&se=2099-05-28T15:01:57Z&st=2021-05-28T07:01:57Z&spr=https,http&sig=1Mf%2F5fA4G5C4fNhzj9kJ0SZSjN0LuM2fueUHijliybE%3D"
            this.labAddForm.labPicUrl = res.result + "?sv=2020-02-10&ss=bfqt&srt=co&sp=rwdlacupx&se=2099-05-28T15:01:57Z&st=2021-05-28T07:01:57Z&spr=https,http&sig=1Mf%2F5fA4G5C4fNhzj9kJ0SZSjN0LuM2fueUHijliybE%3D"
        },

        beforeAvatarUpload(file) {

            const isLt2M = file.size / 1024 / 1024 < 2;

            if (!isLt2M) {
                this.$message.error(this.$t('imageCannotExceed') + ' 2MB!');
            }
            return isLt2M;
        },
        handleUploadError(res, file, fileList) {
        },
        getUserInfo() {
            var that = this
            GetCreateLabInital().then(res => {
                if (res.success) {
          
                    that.labAddForm.ip = res.result.ip
                    that.labAddForm.contactName = res.result.userName
                    that.labAddForm.contactmobile = res.result.mobilePhone
                }
            })
        },
        reset() {
            if (this.activeTab === "first") {
                this.citySelect.queryString = ''

            } else if (this.activeTab === "second") {
                this.factorySelect = {
                    cityName: '',
                    factoryName: '',
                    buildingName: ''
                }

            } else {
                this.labSelect = {
                    cityName: '',
                    factoryName: '',
                    buildingName: '',
                    labName: '',
                    SpaceID: ''
                }

            }
            this.formArea = { DeviceName: "", cityId: "", factoryId: "", buildingId: "", LabId: "", deviceId: "" }
            this.formselect = {
                cityId: "",
                factoryId: "",
                buildingId: "",
                LabId: "",
            }
            this.getDataList()
        },

        async openAddBuilding() {
            this.dialogAddBuilding = true
            let data = await GetCityList();
            this.cityList = data.result
        },

        async getDataList() {
            if (this.activeTab === "first") {
                let skipcount = (this.pagination.current - 1) * this.pagination.pageSize;   //开始条
                let data = await getCityAll(this.citySelect.queryString, '', this.pagination.pageSize, skipcount);
                this.tableDataCity = data.result.items;
                this.pagination.totalPage = data.result.totalCount;
            }

            //getFactoryList
            else if (this.activeTab === "second") {
                let skipcount = (this.pagination.current - 1) * this.pagination.pageSize;   //开始条
                //let data = await getFactoryAll(this.factorySelect.buildingName, this.factorySelect.factoryName, this.factorySelect.cityName, '', '', this.pagination.pageSize, skipcount);
                let data = await getFactoryAll(this.factorySelect.buildingName, this.formselect.factoryId, this.formselect.cityId, '', '', this.pagination.pageSize, skipcount);
                this.tableDataFactory = data.result.items;
                this.pagination.totalPage = data.result.totalCount;
            }

            //getLabList()
            else {
                var ss = this.formselect.cityId
                let skipcount = (this.pagination.current - 1) * this.pagination.pageSize;   //开始条
                //let data = await getLabAll(this.labSelect.labName, this.labSelect.buildingName, this.labSelect.factoryName, this.labSelect.cityName,'','', this.pagination.pageSize, skipcount);
                let data = await getLabAll(this.labSelect.labName, this.formselect.buildingId, this.formselect.factoryId, this.formselect.cityId, '', '', this.labSelect.SpaceID,this.pagination.pageSize, skipcount);
                this.tableDataLab = data.result.items;
                this.pagination.totalPage = data.result.totalCount;

                this.tableDataLab.forEach(function(item,index,array){
                    item.SpaceID=item.spaceID;
                })
            }

        },

        //打开编辑表单
        async openEdit(row) {
            //openEditCityForm
            if (this.activeTab === "first") {
                this.cityEditForm = JSON.parse(JSON.stringify(row));
                this.dialogEditCity = true;
            }
            //openEditFactoryForm
            else if (this.activeTab === "second") {
              
                this.factoryEditForm = {
                    buildingId: row.buildingId,
                    factoryName: row.factoryName,
                    cityId: row.cityId,
                    buildingName: row.buildingName,
                    factoryRemark: row.factoryRemark,
                    factoryCode: row.factoryCode,
                    id: row.id
                }
                // JSON.parse(JSON.stringify(row));
     
                let data = await GetCityList();
                this.cityList = data.result
                this.dialogEditFactory = true
            }
            //openEditLabForm
            else {
                var data = fancha(row.id)
                for (var i in data) {
                    switch (i) {
                        case "0":
                            this.labform.cityId = this.area[data[i]].value
                            this.facList = this.area[data[i]].children
                            break;
                        case "1":
                            this.labform.factoryId = this.facList[data[i]].value
                            this.building = this.facList[data[i]].children
                            break;
                        case "2":
                            this.labform.buildingId = this.building[data[i]].value
                            this.labList = this.building[data[i]].children
                            break;
                        case "3":
                            this.deviveList = this.labList[data[i]].children
                            break;

                    }
                }

                let floordata = await GetByBuildingId(row.buildingId);
                this.floorList = floordata.result.floorIns

                this.labform = JSON.parse(JSON.stringify(row));
                //this.labform.labPicUrl = this.labform.labPicUrl +"?sv=2020-02-10&ss=bfqt&srt=co&sp=rwdlacupx&se=2099-05-28T15:01:57Z&st=2021-05-28T07:01:57Z&spr=https,http&sig=1Mf%2F5fA4G5C4fNhzj9kJ0SZSjN0LuM2fueUHijliybE%3D"
       
                let data1 = await GetCityList();
                this.cityList = data1.result
                this.dialogEditLab = true;

                //将SpaceID转换为数组SpaceIDList [{SpaceID: "1", IDIndex: 1}]
                if(this.labform.SpaceID){
                    this.labform.SpaceIDList = this.labform.SpaceID.split(',').map((item, index) => {
                        return {
                            SpaceID: item
                        }
                    })
                }
                else{
                    this.labform.SpaceIDList =[];
                }
            }
        },

        openBuildingConfig(row) {
      
            this.buildingEditForm = JSON.parse(JSON.stringify(row));   /////////////////////////////

            this.dialogBuilding = true
        },

        async openAdd() {
            // this.getUserInfo()  //自动获取ip和用户信息
            this.cityAddForm = {
                cityName: '',
                cityCode: '',
                longitude: '',
                latitude: '',
                remark: ''
            }
            //openAddCityForm
            if (this.activeTab === "first") {
                this.dialogAddCity = true;
            }
            //openAddFactoryForm
            else if (this.activeTab === "second") {
                // if(this.$refs['factoryAddForm'] !== undefined){
                //   this.$refs['factoryAddForm'].resetFields();
                // }
                this.dialogAddFactory = true;
                let data = await GetCityList();
                this.cityList = data.result;
            }
            //openAddLabForm
            else {
                this.dialogAddLab = true;
                this.labAddForm.labPicUrl = ''
                let data = await GetCityList();
                this.cityList = data.result
                this.labAddForm.SpaceIDList=[];
                this.labAddForm.SpaceID="";
            }
            this.factoryList = []
            this.buildingList = []
            this.floorList = []
        },

        cancelAdd() {
            try {
                if (this.activeTab === "first") {
                    this.dialogAddCity = false
                } else if (this.activeTab === "second") {
                    this.dialogAddFactory = false
                } else {
                    this.dialogAddLab = false
                }
                this.closeAddDialog()
            } catch (e) {
              
            }
        },

        cancelAddBuilding() {
            this.dialogAddBuilding = false
            this.closeAddBuildingDialog()
        },

        // closeEditDialog(){
        //   try{
        //     if(this.activeTab === "first"){
        //       this.$refs['cityEditForm'].resetFields();
        //     }
        //     else if(this.activeTab === "second"){
        //       this.$refs['factoryEditForm'].resetFields();
        //     }
        //     else{
        //       this.$refs['labform'].resetFields();
        //     }
        //   }
        //   catch (e) {
        //     console.log(e)
        //   }
        // },

        closeAddDialog() {
            try {
                if (this.activeTab === "first") {
                    this.cityAddForm = {
                        cityName: '',
                        cityCode: '',
                        remark: '',
                    };
                    this.$refs['cityAddForm'].resetFields();
                } else if (this.activeTab === "second") {
                    this.factoryAddForm = {
                        cityId: '',
                        factoryCode: '',
                        factoryName: '',
                        buildings: [],
                        factoryRemark: '',
                    };
                    this.$refs['factoryAddForm'].resetFields();
                } else {
                    this.labAddForm = {
                        cityId: '',
                        factoryId: '',
                        buildingId: '',
                        floorId: '',
                        labName: '',
                        remark: '',
                        SpaceIDList: [],
                    };
                    this.$refs['labAddForm'].resetFields();
                }
            } catch (e) {
           
            }
        },

        closeAddBuildingDialog() {
            this.buildingAddForm = {
                cityId: '',
                factoryId: '',
                buildingCode: '',
                buildingName: '',
                remark: ''
            };
            this.$refs['buildingAddForm'].resetFields();
        },

        async getFactoryByCityId(cityId) {
            this.labAddForm.factoryId = ""
            this.labAddForm.buildingId = ""
            this.labAddForm.floorId = ""
            let data = await GetByCityId(cityId);
            this.factoryList = data.result
            this.buildingList = []
            this.floorList = []
        },

        async getBuildingByFactoryId(factoryId) {
            this.labAddForm.buildingId = ""
            this.labAddForm.floorId = ""
            let data = await GetByFactoryId(factoryId);
            this.buildingList = data.result
            this.floorList = []
        },

        async getFloorByBuildingId(buildingId) {
            // console.log(FactoryId)
            this.labAddForm.floorId = ""
            let data = await GetByBuildingId(buildingId);
            this.floorList = data.result.floorIns
        
        },

        //添加信息
        async addInfo(formName) {
            try {
                if (this.activeTab === "first") {
                    this.$refs[formName].validate(async valid => {
                        if (valid) {
                            const data = await addCity(this.cityAddForm);
                            this.dialogAddCity = false;
                            if (data.success === true) {
                                this.$message({
                                    message: this.$t('AddedSuccessfully'),
                                    type: "success"
                                });
                                this.getDataList();
                            }
                        }
                    });
                } else if (this.activeTab === "second") {
                    this.$refs[formName].validate(async valid => {
                        if (valid) {
                            // let result = true
                            this.factoryAddForm.buildings.forEach((item, index) => {
                                let no = index + 1
                                if (item.buildingName === '' || item.buildingCode === '') {
                                    // result = result && false
                                    this.$message.error(this.$t('the') + no + this.$t('line') + '：' + this.$t('BuildingCodeAndName'))
                                    throw new Error("breakForEach");
                                }
                            })
                            // if(result){
                          
                            const data = await addFactory(this.factoryAddForm);
                            this.dialogAddFactory = false;
                            if (data.success === true) {
                                this.$message({
                                    message: this.$t('AddedSuccessfully'),
                                    type: "success"
                                });
                                this.getDataList();
                            }
                            // }
                            //this.$message.error("楼宇不能为空");

                        }
                    });
                } else {
                    this.$refs[formName].validate(async valid => {
                        if (valid) {
                            //组合SpaceID
                            let SpaceID = "";
                            this.labAddForm.SpaceIDList=this.labform.SpaceIDList;
                            this.labAddForm.SpaceIDList.forEach((item, index) => {
                                SpaceID += item.SpaceID + ",";
                            })
                            SpaceID = SpaceID.substring(0, SpaceID.length - 1);
                            //赋值给labAddForm的SpaceID
                            this.labAddForm.SpaceID = SpaceID;

                            const data = await addLab(this.labAddForm);
                            if (data.success === true) {
                                this.$message({
                                    message: this.$t('AddedSuccessfully'),
                                    type: "success"
                                });
                                this.getDataList();
                            }
                            this.dialogAddLab = false;
                        }
                    });
                }
            } catch (e) {
              
                if (this.activeTab === "first") {
                    this.dialogAddCity = false;
                } else if (this.activeTab === "second") {
                    this.dialogAddFactory = false;
                } else {
                    this.dialogAddLab = false;
                }
                this.$message.error(e.error.message);
            }

        },

        async addBuildingInfo(formName) {
            try {
                this.$refs[formName].validate(async valid => {
                    if (valid) {
                     
                        const data = await addBuilding(this.buildingAddForm);
                        this.dialogAddBuilding = false
                        if (data.success === true) {
                            this.$message({
                                message: this.$t('AddedSuccessfully'),
                                type: "success"
                            });
                            this.getDataList();
                        }
                        this.dialogAddLab = false;
                    }
                });
            } catch (e) {
            
                this.dialogAddBuilding = false
                this.$message.error(e.error.message);
            }
        },

        async deleteInfo(row) {
            try {
                //deleteCityInfo
                if (this.activeTab === "first") {
                    const data = await deleteCity({
                        Id: row.id
                    });

                    if (data.success === true) {
                        this.$message({
                            message: this.$t('deleteSuccessful'),
                            type: "success"
                        });
                        this.getDataList();
                    }
                } else if (this.activeTab === "second") {
                    const data = await deleteBuilding({
                        Id: row.id
                    });
                    if (data.success === true) {
                        this.$message({
                            message: this.$t('deleteSuccessful'),
                            type: "success"
                        });
                        this.getDataList();
                    }
                } else {
                    const data = await deleteLab({
                        Id: row.id
                    });

                    if (data.success === true) {
                        this.$message({
                            message: this.$t('deleteSuccessful'),
                            type: "success"
                        });
                        this.getDataList();
                    }
                }
            } catch (e) {
                
                this.$message.error(e);
            }
        },

        async deleteFactoryInfo(row) {
            try {
           
                const data = await deleteFactory({
                    Id: row.factoryId
                });
                if (data.success === true) {
                    this.$message({
                        message: this.$t('deleteSuccessful'),
                        type: "success"
                    });
                    this.getDataList();
                }

                // this.$refs[formName].validate(async valid => {
                //   if (valid) {
                //     const data = await deleteFactory({
                //       Id:this.factoryDeleteForm.factoryId
                //     });
                //     this.dialogDeleteFactory = false;
                //     if (data.success === true) {
                //       this.$message({
                //         message: "删除成功",
                //         type: "success"
                //       });
                //       this.getDataList();
                //     }
                //   }
                // });
            } catch (e) {
            
                this.$message.error(e);
            }

        },


        async editInfo(formName = {}) {
            try {
                if (this.activeTab === "first") {
                    this.$refs[formName].validate(async valid => {
                        if (valid) {
                            const data = await editCity(this.cityEditForm);
                            this.dialogEditCity = false;
                            if (data.success) {
                                this.$message({
                                    message: this.$t('EditSuccessful'),
                                    type: "success"
                                });
                                this.getDataList();
                            }
                        }
                    });
                } else if (this.activeTab === "second") {
                    this.$refs[formName].validate(async valid => {
                        if (valid) {
                            // console.log(this.factoryform)
                            // let form = {
                            //   buildingId:this.factoryEditForm.buildingId,
                            //   factoryName:this.factoryEditForm.factoryName,
                            //   cityId:this.factoryEditForm.cityId,
                            //   buildingName:this.factoryEditForm.buildingName,
                            //   remark:this.factoryEditForm.remark,
                            //   id:this.factoryEditForm.id
                            // }
                      
                            const data = await editFactory(this.factoryEditForm);
                            this.dialogEditFactory = false;
                            if (data.success) {
                                this.$message({
                                    message: this.$t('EditSuccessful'),
                                    type: "success"
                                });
                                this.getDataList();
                            }
                        }
                    });
                } else {

                    this.$refs[formName].validate(async valid => {
                        if (valid) {
                            //组合SpaceID
                            let SpaceID = "";
                            this.labform.SpaceIDList.forEach((item, index) => {
                                SpaceID += item.SpaceID + ",";
                            })
                            SpaceID = SpaceID.substring(0, SpaceID.length - 1);
                            //赋值给labform的SpaceID
                            this.labform.SpaceID = SpaceID;

                            const data = await editLab(this.labform);
                            this.dialogEditLab = false;
                            if (data.success) {
                                this.$message({
                                    message: this.$t('EditSuccessful'),
                                    type: "success"
                                });
                                this.getDataList();
                            }
                        }
                    });
                }
            } catch (e) {
       
                if (this.activeTab === "first") {
                    this.dialogEditCity = false;
                } else if (this.activeTab === "second") {
                    this.dialogEditFactory = false;
                } else {
                    this.dialogEditLab = false;
                }
                this.$message.error(e.error.message);
            }
        },

        async editFloorInfo() {
            try {
                
                const data = await editFloor(this.buildingEditForm);
                this.dialogBuilding = false;
                if (data.success) {
                    this.$message({
                        message: this.$t('EditSuccessful'),
                        type: "success"
                    });
                    this.getDataList();
                }
            } catch (e) {
                this.$message.error(e.error.message);
            }
        },

        async pageChange() {
            this.getDataList();
        },

        // 增加行  楼宇
        addBuildRow() {
            let list = {
                buildingName: '',
                buildingRemark: '',
                buildingCode: ''
            };
            this.factoryAddForm.buildings.push(list)
        },
        // 删除选中行 楼宇
        delBuildRow(index, row) {
            this.factoryAddForm.buildings.splice(index, 1);
        },

        //增加行 楼层
        addFloorRow() {
            let iter = {
                floorName: ''
            }
            this.buildingEditForm.floor.push(iter)
        },
        // 删除选中行 楼层
        delFloorRow(index) {
            this.buildingEditForm.floor.splice(index, 1);
        },

        //经纬度合并列
        fileData(row) {
            return this.$t('longitude') + ':' + row.longitude + ',' +this.$t('Dimension')+':' + row.latitude
        },

        mergeLabAddress(row) {
            return row.cityName + " - " + row.factoryName + " - " + row.buildingName + " - " + row.floorName
        },

        mergeFloor(row) {
            let apart = ','
            return row.floor.map(function (obj) {
                if (obj) {
                    if (obj.floorName) {
                        return obj.floorName;
                    } else {
                        apart = ''
                    }
                } else {
                    apart = ''
                }
            }).join(apart);
        },

        //选项卡切换，分页重置
        handleClick() {    //tab,event
         
            this.pagination = {
                current: 1,
                pageSize: 6,
                totalPage: 0
            }
            this.getDataList()
        },
        getFac() {
             
            var a = ''

            this.area.map((item, index) => {
                if (id == item.value) {
                    a = index
                }
            })

            this.facList = this.area[a].children
            this.building = []
            this.labList = []
        },
        getBuild() {
             
            var a = ''

            this.facList.map((item, index) => {
                if (id == item.value) {
                    a = index
                }
            })
            this.building = this.facList[a].children
            this.labList = []
        },
        getLab() {
             
            var a = ''
            this.building.map((item, index) => {
                if (id == item.value) {
                    a = index
                }
            })
            this.labList = this.building[a].children

        },
    }
}
</script>

<style scoped>
#formPer .el-form-item__content {
    line-height: 35px;
    border-left: 1px solid #EBEEF5;
    padding-left: 10px;
}

#formPer>.el-form-item {
    margin-bottom: 0px;
    border-bottom: 1px solid #EBEEF5;
}

#formPer .noborder .el-form-item__content {
    border: 0;
}

#formPer .noborder {
    border: 0;
    margin-top: 20px;
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}

.avatar {
    width: 178px;
    height: 178px;
    display: block;
}
</style>
